export const locale = {
    lang: 'fr',
    data: {
        error: {
            validation: 'fr Validation error',
            userexists: 'fr Employee already exists',
            shippinglinemissing: 'No shipping line is set on this order',
            bookingtypemissing: 'No booking type is set on the selected shipping line',
            dfdsnotsupported: 'DFDS ship booking is not yet supported',
            linkedToLeg: 'fr This event cannot be deleted as it is linked to a leg.',
            legnotcommunicated: 'fr Communicate the leg first, then record the call-in for this stop.'
        },
        mobileKit: {
            actions: 'Actions',
            more: 'Plus',
            cancel: 'Annuler',
            clear: 'Effacer',
            apply: 'Appliquer',
            filters: 'Filtres',
            selected: '{{count}} sélectionné(s)',
            selectAllOnPage: 'Tout sélectionner sur cette page',
            dateFrom: 'Du',
            dateTo: 'Au',
            sort: 'Trier',
            sortBy: 'Trier par',
            defaultOrder: 'Ordre par défaut',
            ascending: 'Croissant',
            descending: 'Décroissant',
            done: 'Terminé',
            id: 'ID'
        },
        mobileList: {
            bulkActions: 'Actions groupees',
            processingBulk: 'Operation groupee en cours...',
            noInvoicesTitle: 'Aucune facture',
            noInvoicesText: 'Aucun resultat pour les filtres actuels.',
            noOrdersTitle: 'Aucune commande',
            noOrdersText: 'Aucun resultat pour les filtres actuels.',
            noBatchesTitle: 'Aucun lot',
            noBatchesText: 'Aucun resultat pour les filtres actuels.',
            noRunsTitle: 'Aucune tournee',
            noRunsText: 'Aucun resultat pour les filtres actuels.',
            hasExtras: 'Extras',
            showOrders: 'Afficher les commandes',
            removeFromBatch: 'Retirer du lot',
            hasProblems: 'Problemes de facturation',
            onHold: 'En attente',
            unacceptedExtras: 'Extras non acceptes',
            noPod: 'Pas de POD',
            viewOrder: 'Voir la commande',
            openRun: 'Ouvrir la tournee',
            download: 'Telecharger'
        },
        common: {
            search: 'Rechercher',
            confirmation: 'Confirmation',
            yes: 'Oui',
            no: 'Non',
            error: 'fr Error',
            ok: 'fr OK',
            errorMessage: 'fr Internal server error. Please contact to the administrator.',
            tooManyRequests: 'fr Too many requests',
            tooManyRequestsMessage:
                'fr The system is receiving too many requests from your connection. Please wait {{ seconds }} seconds and try again.',
            confirmDelete: {
                message: 'Êtes-vous sûr de vouloir supprimer {{ discriminator }}?'
            },
            confirmRemoveOrderFromBatch: {
                message: 'Retirer la commande {{orderNo}} de ce lot ?'
            },
            sentPdfEmails: 'fr PDF Emails have been sent to recipients.',
            listActions: 'fr Actions',
            noSelectedColumn: 'fr Please, select at least one column to be displayed.',
            noSelectedOrder: 'Please, select at least one order before creating a Run',
            haulierOrderDatesError: 'Delivery window is set before Collection Window',
            forms: {
                validationMessages: {
                    required: {
                        default: 'Le champ {{_fieldName}} est requise'
                    },
                    requireAtLeastOne: {
                        default: 'Au moins un {{_fieldName}} doit être sélectionné'
                    },
                    floatRange: {
                        default: '{{_the}} {{_fieldName}} devrait être comprise entre {{min}} et {{max}}'
                    },
                    maxlength: {
                        default: '{{_the}} {{_fieldName}} peut avoir un maximum de {{requiredLength}} caractères'
                    },
                    minlength: {
                        default: '{{_the}} {{_fieldName}} doit comporter au moins {{requiredLength}} caractères'
                    },
                    min: {
                        default: '{{_the}} {{_fieldName}} doit être supérieur à {{min}}'
                    },
                    max: {
                        default: '{{_the}} {{_fieldName}} doit être au plus {{max}}'
                    },
                    formValid: {
                        default: 'You need to fill in all mandatory fields with valid value, before this can be saved. {{invalidFields}}'
                    },
                    latitudeLongitudenotEqualToZero: {
                        default: 'Latitude and Longitude must not be equal to zero simultaneously'
                    },
                    collectionTimeShouldBeBeforeDeliveryTime: {
                        default: 'Collection End Time should be before Delivery Start Time'
                    },
                    errorFields: {
                        default: 'There are errors in the following fields - please correct before attempting to save: {{_fieldList}}'
                    },
                    confirmPassword: {
                        default: 'fr Confirm password and password not equal'
                    },
                    email: {
                        default: 'Invalid email'
                    },
                    timeRange: {
                        default: 'Invalid time window'
                    },
                    dateTimePast: {
                        default: 'fr Date-time is in the past'
                    },
                    maxWeight: {
                        default: 'Invalid weight'
                    },
                    pastDate: {
                        default: "Date can't be set on the past"
                    },
                    sameCurrency: {
                        default: 'fr Currencies cannot be the same'
                    },
                    rate: {
                        default: 'Rate cannot be blank or Zero if Tariff Override is not set'
                    },
                    noMatchError: {
                        default: "Password doesn't match."
                    },
                    collectionInThePast: {
                        default: "Collection date can't be set in the past"
                    },
                    deliverBeforeCollection: {
                        default: "Order can't be delivered before collected"
                    },
                    minGreaterThanMax: {
                        default: 'La valeur maximale doit être inférieure à la valeur minimale'
                    }
                },
                unsavedChangesWarning: {
                    default: 'You have unsaved changes, are you sure you want to continue?'
                }
            },
            fields: {
                name: 'Name',
                accountNo: 'Account Number',
                vatRegNo: 'VAT Registration Number',
                website: 'Website URL',
                registrationNo: 'Registration Number',
                currencyId: 'Currency',
                invoiceTemplateId: 'Invoice Template',
                line1: 'Line 1',
                townCity: 'Town',
                countyState: 'County',
                postCodeZip: 'Post Code'
            },
            selection: {
                selectAll: 'Tout',
                selectNone: 'Aucun'
            },
            genderWords: {
                m: {
                    _a: 'Un',
                    _the: 'Le'
                },
                f: {
                    _a: 'Une',
                    _the: 'La'
                }
            }
        }
    }
};
